export const GET_ALL_OPD_REPORT_BEGIN = "GET_ALL_OPD_REPORT_BEGIN";
export const GET_ALL_OPD_REPORT_SUCCESS = "GET_ALL_OPD_REPORT_SUCCESS";
export const GET_ALL_OPD_REPORT_ERROR = "GET_ALL_OPD_REPORT_ERROR";

export const GET_ALL_CANCELLED_OPD = "GET_ALL_CANCELLED_OPD";
export const GET_ALL_CANCELLED_OPD_BEGIN = "GET_ALL_CANCELLED_OPD_BEGIN";
export const GET_ALL_CANCELLED_OPD_ERROR = "GET_ALL_CANCELLED_OPD_ERROR";
